import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'tr-multiselect',
  template: `
  <ng-select [items]="to.options"
      [bindLabel]="labelProp"
      [bindValue]="valueProp"
      [multiple]="to.multiple"
      [placeholder]="to.placeholder"
      [closeOnSelect] = "closeOnSelectProp"
      [formControl]="formControl">
    </ng-select>
    <i *ngIf="to.displayCorrect" class="fa fa-check text-success fa-2x" aria-hidden="true"></i>
    <i *ngIf="to.displayWrong" class="fa fa-times text-danger fa-2x" aria-hidden="true"> </i>
  `
})

// added custom styles for induction quiz question type select-one(-optional)

export class MultiselectComponent extends FieldType {
  get labelProp(): string { return this.to.labelProp || 'label'; }
  get valueProp(): string { return this.to.valueProp || 'value'; }
  get groupProp(): string { return this.to.groupProp || 'group'; }
  get closeOnSelectProp(): boolean { return this.to.closeOnSelectProp || false ; }
}



// WEBPACK FOOTER //
// ./src/app/stage/containers/multiselect/multiselect.component.ts